export default "__VITE_ASSET__$Q11nJNi__"